/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';

export const LengthCheckingMixin = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  checkLength(e: any) {
    const text = $(e.target).val();
    // @ts-expect-error TS(2339): Property 'maxLength' does not exist on type '{ che... Remove this comment to see the full error message
    const maxLength = this.maxLength || 16384;
    // @ts-expect-error TS(2532): Object is possibly 'undefined'.
    const isEmpty = text.length === 0 || /^\s*$/.test(text);
    // @ts-expect-error TS(2532): Object is possibly 'undefined'.
    const isTooLong = !isEmpty && text.length > maxLength;
    // @ts-expect-error TS(2551): Property 'preventSubmit' does not exist on type '{... Remove this comment to see the full error message
    if (this.preventSubmit != null) {
      // @ts-expect-error TS(2551): Property 'preventSubmit' does not exist on type '{... Remove this comment to see the full error message
      this.preventSubmit(isTooLong, isEmpty);
    } else {
      this._preventSubmit(isTooLong, isEmpty);
    }
  },

  // @ts-expect-error TS(7023): '_preventSubmit' implicitly has return type 'any' ... Remove this comment to see the full error message
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  _preventSubmit(isTooLong: any, isEmpty: any) {
    // @ts-expect-error TS(2339): Property '$el' does not exist on type '{ checkLeng... Remove this comment to see the full error message
    $('.js-too-long-warning', this.$el).toggleClass('hide', !isTooLong);
    // @ts-expect-error TS(2339): Property '$el' does not exist on type '{ checkLeng... Remove this comment to see the full error message
    $('.js-is-empty-warning', this.$el).toggleClass('hide', !isEmpty);
    // @ts-expect-error TS(2339): Property '$el' does not exist on type '{ checkLeng... Remove this comment to see the full error message
    return $('input[type="submit"]', this.$el).prop(
      'disabled',
      isEmpty || isTooLong,
    );
  },
};
